export default __webpack_public_path__ + "static/media/Group9.24c64efd.svg";